// extracted by mini-css-extract-plugin
export var active = "_e7-7";
export var container = "_e7-0";
export var evenWidth = "_e7-4";
export var large = "_e7-5";
export var outlet = "_e7-8";
export var slide = "_e7-2";
export var small = "_e7-6";
export var tab = "_e7-3";
export var tabs = "_e7-1";